import React from "react";
import styles from "../Select-ItemContainer.module.css";
import {CYNYSymbolTable} from '../../../Components/Table/CYNYSymbol_Table';


export class SelectedCYNYSymbol extends React.PureComponent {
    fnListener = (sender, evt) => {
        this.forceUpdate();
    }

    componentDidMount() {
        const {graph} = this.props;
        graph.addListener('PACKAGE', this.fnListener);
        graph.addListener('RENAME_SYMBOL_PROPERTY', this.fnListener)
    }

    componentWillUnmount() {
        const {graph} = this.props;
        graph.removeListener(this.fnListener);
    }


    createData = () => {
        const {graph} = this.props;
        const cell = graph.getSelectionCells()[0];

        const selectedSymbol = cell.shapeValue.SymbolProperties
        return selectedSymbol.map((item, index) => {
            if (item.Name === 'REFDES') {
                return {
                    key: `unique ${index}`,
                    property: item.Name,
                    isEdit: true,
                    cell,
                    value: cell.getRefdesName()
                }
            }
            return {
                key: `unique ${index}`,
                property: item.Name,
                isEdit: false,
                value: cell.getPropertyName(item)
            }
        });
    }

    render() {
        const {onUpdateSymbolData, selectedObject, graph} = this.props;
        const data = this.createData();
        return (
            <div>
                <div className={styles.pinout_title}>
                    <span>SELECTED SYMBOL</span>
                </div>
                <CYNYSymbolTable graph={graph} selectedObject={selectedObject} originData={data}
                                 onUpdateSymbolData={onUpdateSymbolData}/>
            </div>
        )
    }
}
